import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  inactiveIcon: {
    opacity: '0.7',
  },
  inactiveText: {
    opacity: '0.7',
  },
  activeLink: {
    opacity: '1',
  },
  activeContainer: {
    backgroundColor: '#1e2125',
  },
  tooltipInvisible: {
    visibility: 'hidden',
    '& .MuiSvgIcon-root': {
      visibility: 'visible',
    },
  },
  listContainer: {
    boxShadow: 'inset 0px 2px 5px 0px #00000040',
    minWidth: '63px',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: '#212327',
    },
  },
  iconContainer: {
    minWidth: '63px',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: '#212327',
    },
  },
  linkDisabled: {
    pointerEvents: 'none',
    '&:hover': {
      cursor: 'not-allowed',
    },
  },
  listItemText: {
    color: '#EAF2FF',
    textTransform: 'uppercase',
    padding: '7px 0',
  },
  listItemSubText: {
    color: '#EAF2FF',
    textTransform: 'uppercase',
  },
  nested: {
    paddingLeft: theme.spacing(10),
  },
  expanderToggle: {
    fill: '#EAF2FF',
  },
}));

export default useStyles;
